// Copyright (c) 2021 Deere & Company

import './index.scss';

import * as busyCounter from '../../shared/action-creator/busy-counter';
import React, { Component } from 'react';
import { createErrorMessage, createSuccessMessage } from '../../shared/action-creator/alert-messages';
import { formatGivenDate, formatLocalDate } from '../../shared/services/common-functions';
import {
    getFactoryDayStatus, getShippingDayStatus, postFactoryDayStatus, postShippingDayStatus
} from '../atp-calendar/repositories';
import BreadCrumbs from '../../common/components/bread-crumbs';
import BusyCounterLoadingIndicator from '../../shared/components/busyCounter/busy-counter-loading-indicator';
import Calendar from '../common/components/calendar';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { showLoadingIndicator } from '../../shared/state/busy-counter';
import { withRouter } from 'react-router-dom';

class AtpCalendarDetail extends Component {

    state = {
        result: [],
        type: 'factory',
        location: '',
        month: 0,
        year: 0
    };

    componentDidMount = () => {

        const query = new URLSearchParams( this.props.location.search );
        const queryType = query.get( 'type' );
        const queryLocation = query.get( 'location' );
        const queryMonth = query.get( 'month' );
        const queryYear = query.get( 'year' );
        this.loadInitialData( queryType, queryMonth, queryYear, queryLocation );

    }

    loadInitialData = ( queryType, queryMonth, queryYear, queryLocation ) => {

        const date = new Date();
        const year = Number.isNaN( queryYear ) ? date.getFullYear() : Number( queryYear );
        const month = Number.isNaN( queryMonth ) ? date.getMonth() : Number( queryMonth );
        const startDay = new Date( year, month, 1 );
        const endDay = new Date( new Date( startDay ).setMonth(
            startDay.getMonth() + 1
        ) ).setDate( 0 );

        this.setState( {
            year,
            month
        } );

        if ( queryType === 'shipping' ) {

            this.setState( {
                type: 'shipping',
                location: queryLocation
            } );
            this.props.increaseCounter();
            getShippingDayStatus( formatLocalDate( startDay, 'YYYY-MM-DD' ), formatLocalDate( endDay, 'YYYY-MM-DD' ), queryLocation ).then( response => {

                this.setState( {
                    result: response
                } );
                this.props.decreaseCounter();

            } ).catch( () => {

                this.props.decreaseCounter();

            } );

        } else {

            this.props.increaseCounter();
            getFactoryDayStatus( formatLocalDate( startDay, 'YYYY-MM-DD' ), formatLocalDate( endDay, 'YYYY-MM-DD' ) ).then( response => {

                this.setState( {
                    result: response
                } );
                this.props.decreaseCounter();

            } ).catch( () => {

                this.props.decreaseCounter();

            } );

        }

    }

    processResult = result => {

        const res = [...result];
        res.sort( ( a, b ) => a.date - b.date );
        const mthYear = [];
        res.forEach( day => {

            const noshippingdate = formatGivenDate( day.date, 'YYYY-MM-DDTHH:mm:SS' );
            const year = new Date( noshippingdate ).getFullYear();
            const mth = new Date( noshippingdate ).getMonth();
            const date = new Date( noshippingdate ).getDate();

            if ( !mthYear[year] ) mthYear[year] = [];
            if ( !mthYear[year][mth] ) mthYear[year][mth] = [];
            mthYear[year][mth][date] = day;
            mthYear[year][mth][date].year = year;
            mthYear[year][mth][date].mth = mth;

        } );
        const { month, year } = this.state;
        return mthYear[year][month];

    }

    handleMonthClick = ( m, y ) => {

        const { pathname } = this.props.history.location;
        const { type, location } = this.state;
        this.props.history.push( `/${pathname.split( '/' )[1]}/parameters/atp-calendar/calendar-detail?type=${this.state.type}&month=${m - 1}&year=${y}&location=${location}` );

        this.props.increaseCounter();
        this.setState( {
            result: []
        } );

        this.props.decreaseCounter();

        this.loadInitialData( type, m - 1, y, location );

    }

    handleReset = () => {

        const {
            month, year
        } = this.state;
        this.handleMonthClick( month + 1, year );

    }

    getChanges = data => {

        const {
            month, year
        } = this.state;
        const info = [];
        data.forEach( ( date, index ) => {

            if ( date && date.nonProdDayFlag !== 'P' ) {

                info.push( {
                    date: `${year}-${month < 9 ? '0' : ''}${month + 1}-${index}`,
                    // date: formatGivenDate( new Date( `${year}-${month + 1}-${index}` ), 'YYYY-MM-DD' ),
                    nonProdDayFlag: date.nonProdDayFlag
                } );

            }

        } );
        return info;

    }

    handleSubmit = data => {

        const { pathname } = this.props.history.location;
        const {
            type, month, year, location
        } = this.state;

        const info = this.getChanges( data );

        if ( type === 'factory' ) {

            postFactoryDayStatus( month + 1, year, info ).then( resp => {

                if ( resp ) {

                    this.props.history.push( {
                        pathname: `/${pathname.split( '/' )[1]}/parameters/atp-calendar/calendar`,
                        search: `?type=${type}`,
                        state: {
                            message: `Succesfully Inserted ${resp} rows.`
                        }
                    } );

                }

            } );

        } else if ( type === 'shipping' ) {

            postShippingDayStatus( month + 1, year, location, info ).then( resp => {

                if ( resp ) {

                    this.props.history.push( {

                        pathname: `/${pathname.split( '/' )[1]}/parameters/atp-calendar/calendar`,
                        search: `?type=${this.state.type}&location=${location}`,
                        state: {
                            message: `Succesfully Inserted ${resp} rows.`
                        }
                    } );

                }

            } );

        }

    }

    showDetail = ( month, year ) => {

        const { pathname } = this.props.history.location;
        this.props.history.push( `/${pathname.split( '/' )[1]}/parameters/atp-calendar/calendar-detail?type=${this.state.type}&month=${month}&year=${year}` );

    }

    render () {

        const {
            type, result, location, year, month
        } = this.state;

        const fullRes = result.length > 0 ? this.processResult( [...result] ) : [];
        const heading = type === 'shipping' ? 'Update Shipping Calendar' : 'Update Factory Calendar';

        const calLink = `/${this.props.unit.name}/parameters/atp-calendar/calendar?type=${type}`;

        const crumbs = [{
            link: `/${this.props.unit.name}/parameters/atp-calendar`,
            text: 'ATP Calendar'
        }, {
            link: type === 'factory' ? calLink : `${calLink}&location=${location}`,
            text: type === 'factory' ? 'Factory Calendar' : 'Shipping Calendar'
        }, {
            link: '',
            text: 'Update Calendar'
        }];

        return (
            <section className="main-content">
                <BusyCounterLoadingIndicator busyCounter={this.props.busyCounter} />
                <header>
                    <h2 className="page-header">{heading}</h2>
                </header>

                <main>
                    <section className="section-container">
                        <div className="blurb-section">
                            <BreadCrumbs crumbs={crumbs} />
                        </div>
                        <div className="atp-calendar-index">
                            <table className="day-index">
                                <tbody>
                                    <tr>
                                        <td className="index-color production-day" />
                                        <td>{type === 'factory' ? 'Production Day' : 'Shipping Day'}</td>
                                    </tr>
                                    {type === 'factory' && (
                                        <tr>
                                            <td className="index-color holiday-day" />
                                            <td>Shutdown - Holiday</td>
                                        </tr>
                                    )}
                                    <tr>
                                        <td className="index-color shutdown-day" />
                                        <td>{type === 'factory' ? 'Shutdown - Factory' : 'No Shipping'}</td>
                                    </tr>
                                </tbody>
                            </table>
                            { type === 'shipping' && <div className="location-info">Inventory Location: {location}</div>}
                        </div>
                        <div className="atp-calendar-detail">
                            { year !== 0 && (
                                <Calendar
                                    month={month}
                                    year={year}
                                    data={fullRes}
                                    detail={true}
                                    type={type}
                                    onSubmit={this.handleSubmit.bind( this )}
                                    onMonthClick={this.handleMonthClick.bind( this )}
                                    resetDates={this.handleReset.bind( this )}
                                />
                            )}
                        </div>
                    </section>
                </main>
            </section>
        );

    }

}

const mapStateToProps = state => ( {
    busyCounter: showLoadingIndicator( state.application.busyCounter ),
    unit: state.application.unit,
    accessToken: state.oktaState.oktaState.accessToken
} );

AtpCalendarDetail.displayName = 'AtpCalendarDetail';
AtpCalendarDetail.propTypes = {
    busyCounter: PropTypes.bool.isRequired,
    increaseCounter: PropTypes.func.isRequired,
    decreaseCounter: PropTypes.func.isRequired,
    unit: PropTypes.object,
    location: PropTypes.object,
    history: PropTypes.object
};
const mapDispatchToProps = dispatch => ( {
    increaseCounter: () => dispatch( busyCounter.increaseBusyCounter() ),
    decreaseCounter: () => dispatch( busyCounter.decreaseBusyCounter() ),
    createSuccessMessage: message => dispatch( createSuccessMessage( message ) ),
    createErrorMessage: message => dispatch( createErrorMessage( message ) )
} );
export default connect(
    mapStateToProps, mapDispatchToProps
)( withRouter( AtpCalendarDetail ) );
